<template>
  <div class="addMain bigMain">
    <!-- 配置物模型-->
    <el-card shadow="never">
      <div v-if="$route.meta.routeList.length>1" class="returnBtn" @click="goBack()">
        <i class="el-icon-back"></i>
      </div>
      <div class="cardTop">
        <h1>配置物模型-上行功能定义</h1>
      </div>
      <div class="cardBottom">
        <div class="addIntroduce">
          <h3>
            配置设备协议的物模型中的上行功能。先点击“
            添加功能”按钮，再添加属性。
            注意顺序，必须按照说明书内协议解析顺序添加。可拖动调整按钮调整顺序。
          </h3>
        </div>
        <div class="tabSuit">
          <el-button class="btnAdd" size="small" @click="addEnclaves('add')">
            添加功能
          </el-button>
          <el-tabs class="configTab" v-model="editableTabsValue2" type="card" closable @tab-remove="removeTab">
            <el-tab-pane v-for="item in editableTabs" :key="item.name" :label="item.title" :name="item.name">
              <!-- 包头信息 -->
              <div class="clearfix">
                <el-button size="small" type="text" class="pull-left" style="margin-left:15px;" @click="clonedEnclaves(item, 'clone')">
                  克隆</el-button>
                <el-button size="small" type="text" class="pull-left" style="margin-left:15px;" @click="modifyBtn(item.id)">
                  编辑</el-button>
                <ul class="infoBt clearfix pull-left">
                  <li>
                    <span>code</span><br />
                    <span>{{ item.packet.code }}</span>
                  </li>
                </ul>
              </div>

              <!-- table -->
              <el-table :data="item.content.tableData" border row-key="id" align="left">
                <el-table-column type="index" label="序号" width="50" align="center">
                </el-table-column>
                <el-table-column label="名称" prop="name">
                  <template slot-scope="scope">
                    <el-input size="small" v-model="scope.row.name"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="标识" prop="code">
                  <template slot-scope="scope">
                    <el-input size="small" v-model="scope.row.code"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="数据类型" width="200px" prop="dataType">
                  <template slot-scope="scope">
                    <el-select size="small" v-model="scope.row.dataType" placeholder="未选择" @change="dataTypeChange(scope.row)">
                      <el-option v-for="item in dataTypeList" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                    <span v-if="scope.row.dataType == 1">
                      <el-input v-model="scope.row.dataMin" style="width:46%" size="small" placeholder="最小值"></el-input>
                      -
                      <el-input v-model="scope.row.dataMax" style="width:46%" size="small" placeholder="最大值"></el-input>
                    </span>

                    <span v-else-if="scope.row.dataType == 2">
                      0 - <el-input v-model="scope.row.boolZero" style="width:48%" size="small" placeholder="如：关">
                      </el-input>
                      <br>
                      1 - <el-input v-model="scope.row.boolOne" style="width:48%" size="small" placeholder="如：开">
                      </el-input>
                    </span>
                    <span v-else-if="scope.row.dataType == 5">
                      <el-button @click.native.prevent="addEnumOption(scope.$index, item.content.tableData)" type="text" size="mini" icon="el-icon-plus">
                      </el-button>
                      <div>
                        <span v-for="(enumOption,optionIndex) in scope.row.dataEnumOptions">
                          <el-input v-model="enumOption.enumValue" style="width:45%" size="small" placeholder="枚举值">
                          </el-input> -
                          <el-input v-model="enumOption.enumDesc" style="width:45%" size="small" placeholder="枚举项的描述">
                          </el-input>
                          <el-button v-if="scope.row.dataEnumOptions.length > 1" icon="el-icon-delete" @click.native.prevent="deleteEnumOption(scope.$index, item.content.tableData,optionIndex)" type="text" size="mini">
                          </el-button>
                          <br>
                        </span>
                      </div>

                    </span>
                  </template>
                </el-table-column>
                <el-table-column label="单位" prop="dataUnit" width="80px" placeholder="请输入">
                  <template slot-scope="scope">
                    <span v-if="scope.row.dataType == 1 || scope.row.dataType == 4">
                      <el-input size="small" v-model="scope.row.dataUnit"></el-input>
                    </span>
                    <span v-else>
                      --
                    </span>

                  </template>
                </el-table-column>
                <el-table-column label="公式" prop="formula" width="120px" placeholder="请输入" :render-header="renderFormula">
                  <template slot-scope="scope">
                    <span v-if="scope.row.dataType == 2 || scope.row.dataType == 5">
                      --
                    </span>
                    <span v-else-if="scope.row.dataType != 2">
                      <el-input type="textarea" :rows="2" size="small" maxlength="500" v-model="scope.row.formula">
                      </el-input>
                    </span>
                  </template>
                </el-table-column>
                <el-table-column label="长度(字节数)" prop="length" width="80px" placeholder="请输入">
                  <template slot-scope="scope">
                    <span v-if="scope.row.dataType == 2">
                      <el-input disabled="true" size="small" min="0" type="number" readonly v-model="scope.row.length">
                      </el-input>
                    </span>
                    <span v-else-if="scope.row.dataType != 2">
                      <el-input size="small" min="0" type="number" v-model="scope.row.length"></el-input>
                    </span>

                  </template>
                </el-table-column>
                <el-table-column label="是否存储" prop="storage">
                  <template slot-scope="scope">
                    <el-select size="small" v-model="scope.row.storage" placeholder="未选择">
                      <el-option v-for="item in storageList" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column label="说明" prop="fieldDesc" width="200px">
                  <template slot-scope="scope">
                    <el-input size="small" min="0" maxlength="200" :rows="4" type="textarea" v-model="scope.row.fieldDesc">
                    </el-input>
                  </template>
                </el-table-column>
                <el-table-column label="" prop="" width="130px">
                  <template slot-scope="scope">
                    <el-row>
                      <el-col :span="8">
                        <el-button @click.native.prevent="
                            deleteRow(scope.$index, item.content.tableData)
                          " type="text" size="small">
                          移除
                        </el-button>
                        <br />
                        <el-button @click.native.prevent="
                            copyRow(scope.$index, item.content.tableData)
                          " type="text" size="small">
                          克隆
                        </el-button>
                      </el-col>
                      <el-col :span="8">
                        <el-button style="padding:5px 10px ;margin:4px 0" size="mini" :disabled="scope.$index === 0" @click="
                            moveUp(
                              scope.$index,
                              scope.row,
                              item.content.tableData
                            )
                          "><i class="el-icon-arrow-up"></i></el-button>
                        <br>
                        <el-button style="padding: 5px 10px ;margin:4px 0" size="mini" :disabled="
                            scope.$index === item.content.tableData.length - 1
                          " @click="
                            moveDown(
                              scope.$index,
                              scope.row,
                              item.content.tableData
                            )
                          "><i class="el-icon-arrow-down"></i></el-button>
                      </el-col>
                      <el-col :span="8">
                        <el-button style="padding:5px 10px ;margin:4px 0" size="mini" :disabled="scope.$index === 0" @click="
                            moveTop(
                              scope.$index,
                              scope.row,
                              item.content.tableData
                            )
                          "><i class="el-icon-upload2"></i></el-button>
                        <br>
                        <el-button style="padding: 5px 10px ;margin:4px 0" size="mini" :disabled="
                            scope.$index === item.content.tableData.length - 1
                          " @click="
                            moveBottom(
                              scope.$index,
                              scope.row,
                              item.content.tableData
                            )
                          "><i class="el-icon-download"></i></el-button>
                      </el-col>
                    </el-row>
                  </template>
                </el-table-column>
              </el-table>
              <el-button @click.native.prevent="addRow(item.content.tableData)" type="text" size="small">
                添加行
              </el-button>
            </el-tab-pane>
            <!-- 修改功能 -->
            <el-dialog title="修改功能" :visible.sync="modifyDialog">
              <el-form :model="modifyForm" ref="modifyForm" :rules="rules">
                <el-form-item label="code" prop="code" style="background-color:transparent;border-bottom:none">
                  <el-input v-model="modifyForm.code" placeholder="请输入" autocomplete="off" style="margin-top:30px;width:100%;"></el-input>
                </el-form-item>
                <el-form-item label="功能名称" prop="name" style="background-color:transparent;border-bottom:none">
                  <el-input v-model="modifyForm.name" placeholder="请输入" autocomplete="off" style="margin-top:30px;width:100%;"></el-input>
                </el-form-item>
              </el-form>
              <div slot="footer" class="dialog-footer">
                <el-button @click="modifyDialog = false">取 消</el-button>
                <el-button type="primary" @click="modifyConfirm('modifyForm')">确 定</el-button>
              </div>
            </el-dialog>
          </el-tabs>
        </div>
        <el-form>
          <el-form-item>
            <el-button type="text" @click="$router.history.go(-1)">取消</el-button>
            <el-button style="float: right" v-if="flag != 'edit'" type="success" @click="onSubmit(1)">创建完成</el-button>

            <el-button v-if="flag != 'edit'" type="primary" @click="onSubmit(2)">创建下行包</el-button>
            <el-button v-if="flag == 'edit'" type="primary" @click="editOnSubmit()">完成</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-dialog title="创建功能" :visible.sync="dialogFormVisible">
      <el-form :model="editForm" ref="editForm" :rules="rules">
        <el-form-item label="功能编码" prop="code" style="background-color:transparent;border-bottom:none">
          <el-input v-model="editForm.code" placeholder="请输入" autocomplete="off" style="margin-top:30px;width:100%;">
          </el-input>
        </el-form-item>
        <el-form-item label="功能名称" prop="name" style="background-color:transparent">
          <el-input v-model="editForm.name" placeholder="请输入" autocomplete="off" style="margin-top:30px;width:100%;">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirm('editForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import API from "../../api/api";
import Sortable from "sortablejs";
export default {
  data() {
    return {
      user_name: this.$cookies.get("user_name"),
      distinguish: "",
      cloneTarget: {},
      //校验
      rules: {
        code: [{
          required: true,
          message: "请填写功能code值",
          trigger: "blur"
        }],
        name: [{
          required: true,
          message: "请填写功能名称",
          trigger: "blur"
        }]
      },
      flag: this.$route.query.flag,
      ids: this.$route.query.id,
      protocolType: this.$route.query.protocolType,
      dialogFormVisible: false, //创建窗口
      modifyDialog: false,
      editForm: {},
      modifyForm: {}, //修改窗口数据
      editableTabsValue2: "1",
      editableTabs: [],
      dataTypeList: [
        //数据类型下拉
        {
          value: 2,
          label: "布尔类型"
        },
        {
          value: 1,
          label: "数值类型"
        },
        {
          value: 3,
          label: "字符串"
        },
        {
          value: 4,
          label: "16进制"
        },
        {
          value: 5,
          label: "枚举类型"
        }
      ],
      storageList: [
        //数据是否存储
        {
          value: 0,
          label: "不存储"
        },
        {
          value: 1,
          label: "存储"
        }
      ],
      commonFormula: [{
        name: '16进制转10进制',
        val: 'parseInt({},16)'
      },
      {
        name: '10进制转16进制',
        val: '{}.toString(16)'
      },
      {
        name: '高低位转换',
        val: 'reverse({})'
      },
      {
        name: '转为IEEE754格式',
        val: 'IEEE754()'
      },
      ]
    };
  },
  created() { },
  methods: {

    dataTypeChange(obj) {
      console.log(obj);
      if (obj.dataType == 5 || obj.dataType == 2) {
        obj.formula = ""
        if (obj.dataType == 2) {
          obj.length = "1"
        }
      } else {
        this.$set(obj, "length", "")
        obj.length = ""
      }
    },

    deleteEnumOption(rowIndex, data, optionIndex) {
      data[rowIndex].dataEnumOptions.splice(optionIndex, 1);
    },

    addEnumOption(rowIndex, data) {
      if (data[rowIndex]['dataEnumOptions']) {
        data[rowIndex].dataEnumOptions.push({
          enumValue: '',
          enumDesc: ''
        })
      } else {
        //实时渲染dom
        this.$set(data[rowIndex], "dataEnumOptions", [{
          enumValue: '',
          enumDesc: ''
        }])
      }
    },

    //在渲染表头的时候，会调用此方法
    renderFormula(h, {
      column
    }) {
      return h('span', [
        h('span', column.label),
        h('span', {
          style: 'margin-left: 5px;color:green',
          attrs: {
            title: '公式：用于解析，计算或转换字段数值，得出准确结果。',
          },
        }, "?"),
        h('el-popover', {
          attrs: {
            trigger: "hover",
            placement: "top-start",

          },
        },
          [
            h('div', {
              style: {
                cursor: 'pointer'
              }
            },
              [
                h('p', "公式：用于解析，计算或转换字段数值，得出准确结果。"),
                h('p', {
                  style: 'margin-bottom:10px',
                }, "支持js计算公式。"),
                h('span', "常用公式："),
                h('span', {
                  style: 'color:#FF2525',
                }, "* 按住拖拽到指定位置即可完成复制."),
                h('div', {
                  style: 'margin-top:10px',
                }, [
                  this.commonFormula.map(item => {
                    return h('span', {
                      style: {
                        color: '#66B8FF',
                        marginRight: '8px'
                      },
                      attrs: {
                        draggable: "true", //设置可拖拽
                      },
                      on: {
                        dragstart: function (ev) { //拖拽事件内容设置
                          ev.dataTransfer.setData("Text", item.val);
                        }
                      }
                    }, item.name)
                  })
                ])
              ]
            ),
            h('el-link', {
              style: 'margin-left: 15px',
              attrs: {
                trigger: "hover",

              },
              props: {
                type: 'primary',
              },
              slot: 'reference',
            }, "插入公式"),
          ]),
      ]);
    },
    copyRow(index, rows) {
      console.log(rows);
      // //浅复制
      // let target = Object.assign({}, rows[index]);
      //深复制
      let target = JSON.parse(JSON.stringify(rows[index]))
      target.id = null;
      rows.push(target);
    },

    //表格移除功能
    deleteRow(index, rows) {
      rows.splice(index, 1);
    },
    //表格添加行
    addRow(row) {
      let i = 0;
      row.push({});
    },
    //添加功能弹框
    addEnclaves(distinguish) {
      this.dialogFormVisible = true;
      this.distinguish = distinguish; //区分是克隆还是新增功能
    },
    //克隆功能
    clonedEnclaves(row, distinguish) {
      let ROW = JSON.stringify(row);
      this.dialogFormVisible = true;
      //只需要克隆table里面的数据
      this.distinguish = distinguish; //区分是克隆还是新增功能
      let target = Object.assign({}, JSON.parse(ROW));
      target.content.tableData.forEach(ele => {
        ele.id = null;
      });
      target.content.id = null;
      target.content.name = null;
      target.content.title = null;
      this.cloneTarget = target;
    },
    //点击进入编辑页
    modifyBtn(id) {
      API.platformDevProtocolViewPacket(id).then(res => {
        if (res.code == 1) {
          this.modifyForm = res.data; //给该功能内容赋值
          this.modifyDialog = true;
        }
      });
    },
    //编辑页面的完成按钮
    modifyConfirm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let para = {
            id: this.modifyForm.id,
            code: this.modifyForm.code,
            name: this.modifyForm.name,
            collectCron: this.modifyForm.collectCron,
            downType: this.modifyForm.downType,
            packetType: 1 //上行包
          };
          let _this = this;
          if (this.user_name == 'suadmin') {
            //修改功能头信息
            API.editPlatformDevProtocolPacketCommon(para.id, para).then(res => {
              if (res.code == 1) {
                _this.$message.success("修改成功");
                _this.modifyDialog = false;
                //用index找到当前组数据
                _this.editableTabs.findIndex(ele => {
                  if (_this.modifyForm.id == ele.id) {
                    //当前id跟遍历出来的id相同时就是这个功能的数据
                    ele.packet = _this.modifyForm;
                    ele.name = _this.modifyForm.name;
                    ele.title = _this.modifyForm.name;
                    ele.devProtocolId = _this.ids,
                      _this.editableTabsValue2 = _this.modifyForm.name;
                  }
                });
              } else {
                this.$message.error(res.msg);
              }
            });
            return;
          }
          //修改功能头信息
          API.editPlatformDevProtocolPacketPrivate(para.id, para).then(res => {
            if (res.code == 1) {
              _this.$message.success("修改成功");
              _this.modifyDialog = false;
              //用index找到当前组数据
              _this.editableTabs.findIndex(ele => {
                if (_this.modifyForm.id == ele.id) {
                  //当前id跟遍历出来的id相同时就是这个功能的数据
                  ele.packet = _this.modifyForm;
                  ele.name = _this.modifyForm.name;
                  ele.title = _this.modifyForm.name;
                  ele.devProtocolId = _this.ids,
                    _this.editableTabsValue2 = _this.modifyForm.name;
                }
              });
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          this.$message.error("请填写完所有必填项");
          return false;
        }
      });
    },
    // 新增功能
    confirm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let para = {
            name: this.editForm.name,
            code: this.editForm.code,
            packetType: 1, //上行包
            devProtocolId: this.ids
          };
          if (this.user_name == 'suadmin') {
            API.platformDevProtocolPacketCommon(para).then(res => {
              if (res.code == 1) {
                let newTabName = this.editForm.name;
                //新增功能
                if (this.distinguish == "add") {
                  //创建功能空table
                  this.editableTabs.push({
                    title: newTabName,
                    name: newTabName,
                    id: res.data.id,
                    packet: res.data,
                    devProtocolId: this.ids,
                    content: {
                      tableData: []
                    }
                  });
                  //克隆功能操作
                } else if (this.distinguish == "clone") {
                  let _this = this;
                  this.editableTabs.push({
                    title: newTabName,
                    name: newTabName,
                    id: res.data.id,
                    packet: res.data,
                    devProtocolId: this.ids,
                    content: {
                      tableData: _this.cloneTarget.content.tableData
                    }
                  });
                }

                this.editableTabsValue2 = newTabName;
                this.dialogFormVisible = false; //隐藏创建窗口
                this.editForm.name = ""; //创建完，初始化创建窗口信息
                this.editForm.code = ""; //创建完，初始化创建窗口信息
              } else {
                this.$message.error(res.msg);
              }
            });
            return;
          }
          API.platformDevProtocolPacketPrivate(para).then(res => {
            if (res.code == 1) {
              let newTabName = this.editForm.name;
              //新增功能
              if (this.distinguish == "add") {
                //创建功能空table
                this.editableTabs.push({
                  title: newTabName,
                  name: newTabName,
                  id: res.data.id,
                  packet: res.data,
                  devProtocolId: this.ids,
                  content: {
                    tableData: []
                  }
                });
                //克隆功能操作
              } else if (this.distinguish == "clone") {
                let _this = this;
                this.editableTabs.push({
                  title: newTabName,
                  name: newTabName,
                  id: res.data.id,
                  packet: res.data,
                  devProtocolId: this.ids,
                  content: {
                    tableData: _this.cloneTarget.content.tableData
                  }
                });
              }

              this.editableTabsValue2 = newTabName;
              this.dialogFormVisible = false; //隐藏创建窗口
              this.editForm.name = ""; //创建完，初始化创建窗口信息
              this.editForm.code = ""; //创建完，初始化创建窗口信息
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          this.$message.error("请填写完所有必填项");
          return false;
        }
      });
    },
    //删除功能，需要调接口
    removeTab(targetName) {
      let tabs = this.editableTabs;
      let activeName = this.editableTabsValue2;
      if (activeName == targetName) {
        tabs.forEach((tab, index) => {
          if (tab.name === targetName) {
            let para = {
              ids: tab.id
            };
            this.$confirm("此操作将永久删除该功能, 是否继续?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            })
              .then(() => {
                if (this.user_name == 'suadmin') {
                  API.delPlatformDevProtocolDeviceProtocolPacketCommon(para).then(
                    res => {
                      if (res.code == 1) {
                        this.$message.success("删除成功");
                        let nextTab = tabs[index + 1] || tabs[index - 1];
                        if (nextTab) {
                          activeName = nextTab.name;
                        }
                        this.editableTabsValue2 = activeName;
                        this.editableTabs = tabs.filter(
                          tab => tab.name !== targetName
                        );
                      } else {
                        this.$message.error(res.msg);
                      }
                    }
                  );
                  return;
                }
                API.delPlatformDevProtocolDeviceProtocolPacketPrivate(para).then(
                  res => {
                    if (res.code == 1) {
                      this.$message.success("删除成功");
                      let nextTab = tabs[index + 1] || tabs[index - 1];
                      if (nextTab) {
                        activeName = nextTab.name;
                      }
                      this.editableTabsValue2 = activeName;
                      this.editableTabs = tabs.filter(
                        tab => tab.name !== targetName
                      );
                    } else {
                      this.$message.error(res.msg);
                    }
                  }
                );
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: "已取消删除"
                });
              });
          }
        });
      }
    },
    //上移
    moveUp(index, row, data) {
      if (index > 0) {
        let upDate = data[index - 1];
        data.splice(index - 1, 1);
        data.splice(index, 0, upDate);
      } else {
        alert("已经是第一条，不可上移");
      }
    },

    //下移
    moveDown(index, row, data) {
      if (index + 1 === data.length) {
        alert("已经是最后一条，不可下移");
      } else {
        let downDate = data[index + 1];
        data.splice(index + 1, 1);
        data.splice(index, 0, downDate);
      }
    },
    moveTop(index, row, data) {
      if (index > 0) {
        let topDate = data[index];
        data.splice(index, 1);
        data.unshift(topDate)
      } else {
        alert("已经是第一条，不可上移");
      }
    },
    moveBottom(index, row, data) {
      if (index + 1 === data.length) {
        alert("已经是最后一条，不可下移");
      } else {
        let bottomDate = data[index];
        data.splice(index, 1);
        data.push(bottomDate)
      }
    },
    //创建上行功能数据
    onSubmit(next) { //next 下一步，1为完成，2为创建下行包
      //把序号fieldOrder传过去给后台
      for (let i = 0; i < this.editableTabs.length; i++) {
        for (
          let j = 0; j < this.editableTabs[i].content.tableData.length; j++
        ) {
          this.editableTabs[i].content.tableData[j].fieldOrder = j + 1;
        }
      }
      if (this.user_name == 'suadmin') {
        API.platformDevProtocolPacketFieldCommon(this.editableTabs).then(res => {
          if (res.code == 1) {
            this.$message.success("配置上行功能成功");
            if (next == 2) {
              this.$router.push({
                path: "/equipment/downlinkPackage",
                query: {
                  id: this.ids,
                  protocolType: this.protocolType
                }
              });
            } else {
              this.$router.push({
                path: "/equipment/equipmentProtocolLibrary"
              });
            }

          } else {
            this.$message.error(res.msg);
          }
        });
        return;
      }
      API.platformDevProtocolPacketFieldPrivate(this.editableTabs).then(res => {
        if (res.code == 1) {
          this.$message.success("配置上行功能成功");
          if (next == 2) {
            this.$router.push({
              path: "/equipment/downlinkPackage",
              query: {
                id: this.ids,
                protocolType: this.protocolType
              }
            });
          } else {
            this.$router.push({
              path: "/equipment/equipmentProtocolLibrary"
            });
          }

        } else {
          this.$message.error(res.msg);
        }
      });
    },
    /**********************修改操作B***************************** */

    //获取上行数据
    getMage() {
      if (this.flag == "edit") {
        let id = this.$route.query.id;
        //获取物模型-上行
        API.platformDevProtocolViewPacketAndField(this.ids, 1).then(res => {
          // 1代表上行包数据
          if (res.code == 1) {
            if (res.data.length != 0) {
              this.editableTabs = res.data;
              this.editableTabsValue2 = res.data[0].name;
            }
          }
        });
      }
    },
    //修改上行包数据
    editOnSubmit() {
      //把序号fieldOrder传过去给后台
      for (let i = 0; i < this.editableTabs.length; i++) {
        for (
          let j = 0; j < this.editableTabs[i].content.tableData.length; j++
        ) {
          let obj = this.editableTabs[i].content.tableData[j]
          obj.fieldOrder = j + 1;
          if (obj.dataType == 5) {
            if (!obj.dataEnumOptions) {
              this.$message.error("枚举类型数据错误");
              return;
            }
            obj.dataEnum = obj.dataEnumOptions.map(e => e.enumValue + ":" + e.enumDesc).join(',');
          } else if (obj.dataType == 2) {
            obj.dataEnum = "0:" + obj.boolZero + ",1:" + obj.boolOne
            delete obj.boolZero
            delete obj.boolOne
          }
        }
      }
      if (this.user_name == 'suadmin') {
        API.editPlatformDevProtocolPacketFieldCommon(this.editableTabs).then(res => {
          if (res.code == 1) {
            this.$message.success("修改成功");
            this.$router.history.go(-1);
          } else {
            this.$message.error(res.msg);
          }
        });
        return;
      }
      API.editPlatformDevProtocolPacketFieldPrivate(this.editableTabs).then(res => {
        if (res.code == 1) {
          this.$message.success("修改成功");
          this.$router.history.go(-1);
        } else {
          this.$message.error(res.msg);
        }
      });
    }
    /**********************修改操作E ***************************** */
  },
  mounted() {
    this.getMage();
  }
};

</script>



// WEBPACK FOOTER //
// src/views/platform/uplinkPackage.vue